"use strict";
console.log(1111111111);
console.log(window);
$(function() {
    $('.buddi-cart-remove').on('click',function(e){
        e.preventDefault();
        console.log(3333);
        if (typeof window.BOLD.common.Shopify.cart == 'undefined') return false;
        if (typeof window.BOLD.common.Shopify.cart.items == 'undefined') return false;        
        
        const globalCartItems = window.BOLD.common.Shopify.cart.items;
        let itemsToDelete = [];
        let currentQty = 0;
        itemsToDelete.push('updates[' + $(this).attr('for') + ']=0'); // this is the main product that is selected to remove
        console.log(11111);
        //fetch the quantity of the main product you are trying to delete
        for (const key in globalCartItems) {
            if (Object.hasOwnProperty.call(globalCartItems, key)) {
                const itemRecord = globalCartItems[key];
                if (itemRecord.id == $(this).attr('for')) {
                    currentQty = itemRecord.quantity;
                }
            }
        }
        console.log(22222);
        //loop through the cart and delete all the dependent items but make sure you delete the right quantity
        for (const key in globalCartItems) {
            if (Object.hasOwnProperty.call(globalCartItems, key)) {
                const itemRecord = globalCartItems[key];
                let skuSplitter = itemRecord.sku.split('|');
                for (const skuloop in skuSplitter) {
                    if (skuSplitter[skuloop] == $(this).attr('for')) {
                        console.log("DELETE ALSO ~ " + itemRecord.id);
                        let qty = 0;
                        // check if the quantity of the dependent item is less than or equal to the main item you are deleting.
                        if (itemRecord.quantity > currentQty) { 
                            qty = parseInt(itemRecord.quantity) - parseInt(currentQty);
                        }
                        itemsToDelete.push('updates[' + itemRecord.id + ']=' + qty);
                    }
                }
            }
        }

        const updates = itemsToDelete.join('&');
        // post the data to update the cart
        $.post( "/cart/update.js", updates, function (data) {
        });
        
        setTimeout(function(){ location.reload(); }, 500);
        
    })
});